





























































import { COLOR_BUTTON_RED } from "@/utils/colors";
import { themedFill } from "@/utils/Theme";
import { Url } from "url";
import { Component, Vue, Prop } from "vue-property-decorator";

import { ButtonState } from "../../common/StateButton.vue";

@Component
export default class ClientDataSectionComponent extends Vue {
  @Prop() title!: string;
  @Prop({ default: "" }) text!: string;
  @Prop() state!: ButtonState;

  @Prop({ default: true }) showButton!: boolean;
  @Prop({ default: false }) showAddButton!: boolean;
  @Prop({ default: false }) showDeleteButton!: boolean;
  @Prop({ default: true }) addMarginAfter!: boolean;
  
  @Prop({ default: null }) link!: Url | null;
  @Prop({ default: "" }) linkText!: string;
  @Prop({ default: null }) link2!: Url | null;
  @Prop({ default: "" }) linkText2!: string;
  @Prop({ default: "" }) linkIntroText!: string;

  onOpenSection() {
    this.$emit("openSection");
  }

  /** The +/− tiles are actions: the brand red, which dark mode swaps for its accent. A getter so a theme switch repaints it. */
  get buttonColor() {
    return themedFill(COLOR_BUTTON_RED);
  }

  onAdd() {
    this.$emit("onAdd");
  }

  onDelete() {
    this.$emit("onDelete");
  }
}
